import { defineComponent as _defineComponent } from 'vue'
import { computed, reactive } from 'vue';
import { BoxGrid, BoxGridBlock, BoxGridItem } from '@/app/components/common/boxGrid';
import { getServices } from '@/app/services';
import { Client, ClientFileCategories, ClientType, Individual } from 'ah-api-gateways';
import LoadingOverlay from 'ah-common-lib/src/common/components/overlays/LoadingOverlay.vue';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { forkJoin } from 'rxjs';
import ClientDocumentReplacer from '@/app/components/settings/partner/ClientDocumentReplacer.vue';
import BackButton from '@/app/components/common/BackButton.vue';
import { useRouter } from 'vue-router/composables';


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientDocumentsManagerView',
  props: {
    clientId: null
  },
  setup(__props: any) {

const props = __props as {
  /**
   * Client id of client to be displayed
   */
  clientId: string;
};



const state = reactive<{
  client: Client | null;
  ubos: Individual[] | null;
}>({
  client: null,
  ubos: null,
});

const requestManager = useRequestManager();

const router = useRouter();

const services = getServices();

const hasUbos = computed(() => state.ubos && state.ubos.length > 0);

const isIndividual = computed(() => state.client?.type === ClientType.INDIVIDUAL);

const innerCol = computed(() => {
  return hasUbos.value ? 12 : 6;
});

const outerCol = computed(() => {
  return hasUbos.value ? 6 : 12;
});

const hiddenFiles = computed(() => {
  return hasUbos.value ? [ClientFileCategories.RESOLUTION_LETTER] : [];
});

function getUboDocDownloadRequest(uboId: string) {
  return services.compliance.getUboDocuments(state.client!.id, uboId);
}

function uploadUboDocumentRequest(id: string, category: ClientFileCategories, file: File) {
  return services.compliance.submitUboDocument(state.client!.id, id, category, file);
}

function goBack() {
  router.push('.');
}

function loadData() {
  requestManager.manager
    .sameOrCancelAndNew(
      'loadData',
      forkJoin([services.client.getClient(props.clientId), services.compliance.listUbos(props.clientId)])
    )
    .subscribe(([client, ubos]) => {
      state.client = client;
      state.ubos = ubos.list as Individual[];
    });
}

function isLastUbo(ubo: Individual) {
  if (!state.ubos) return false;
  return state.ubos.findIndex((u) => u.id === ubo.id) === state.ubos.length - 1;
}

loadData();

return { __sfc: true,props, state, requestManager, router, services, hasUbos, isIndividual, innerCol, outerCol, hiddenFiles, getUboDocDownloadRequest, uploadUboDocumentRequest, goBack, loadData, isLastUbo, BoxGrid, BoxGridBlock, BoxGridItem, ClientFileCategories, LoadingOverlay, ClientDocumentReplacer, BackButton }
}

})